import { AspectRatio } from "../../utils/constants/aspectRatios";

export interface BlogCardProps {
    imageSrc: string;
    imageAlt: string;
    title: string;
    supertitle: string;
    filterValue: string;
    url: string;
}

export const renderBlogCard = (props: BlogCardProps) => {
    return `<vis-card
            class="z-idx-content"
            super-title="${props.supertitle}"
            card-title="${props.title}"
            href="${props.url}"
            aspect-ratio="${AspectRatio.RATIO_4_3}"
            data-filter-value="${props.filterValue}"
        >
          <img
              slot="media-content"
              class="hover:scale"
              src="${props.imageSrc}"
              alt="${props.imageAlt}"
          />
        </vis-card>`;
    }